module.exports = {"insufficient_coins":"Không đủ xu.","error":"Lỗi xử lý đơn hàng.","ordered":"Sản phẩm được đặt."};